var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { createDom } from "../domUtils.mjs";
const styles = `.overlay {
  position: fixed;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  z-index: 989;
  cursor: default;
  overflow-x: hidden;
  overflow-y: hidden;
  font-size: 1.4rem;
  font-family: "\\30E1\\30A4\\30EA\\30AA", Meiryo, "\\30D2\\30E9\\30AE\\30CE\\89D2\\30B4 Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "\\FF2D\\FF33\\FF30\\30B4\\30B7\\30C3\\30AF", "MS PGothic", arial, helvetica, sans-serif;
}

@media (min-width: 600px) {
  .overlay {
    font-size: 1.4rem; /* minimum font size for screens 600px and wider */
  }
}

@media (max-width: 600px) {
  .overlay {
    font-size: 5vmin; /* font size scales with viewport width for screens narrower than 600px */
  }
}

.overlay * {
  box-sizing: border-box;
}

.container {
  opacity: 0;
  top: 0px;
  width: 85%;
  max-width: 320px;
  max-height: 80%;
  margin: auto 10px;
  background-color: #fff;
  box-shadow: 0 2px 8px 2px rgba(0,0,0,.5);
  display: block;
  overflow: auto;
  position: fixed;
  text-align: center;
  padding: 20px;
  padding-top: 30px;
  border-radius: 12px;
  transition: top 0.2s ease-out 0.0s, opacity 0.1s;
}

.button {
  text-shadow: 0px 1px 0.5px rgba(0, 0, 0, 0.3);
  background: linear-gradient(180deg, #36D100 0%, #008F64 100%);
  text-align: center;
  color: #fff;
  font-size: 18px;
  width: 150px;
  height: 40px;
  border-radius: 8px;
  padding: 7px 10px;
  margin-top: 10px;
}`;
class BasePopup extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "container");
    __publicField(this, "onCloseCallback");
    this.attachShadow({ mode: "open" });
    const style = createDom("style", void 0, this.shadowRoot);
    style.textContent = styles;
    const overlay = createDom("div", "overlay", this.shadowRoot);
    this.container = createDom("div", "container", overlay);
  }
  connectedCallback() {
    setTimeout(() => {
      this.container.style.top = "44px";
      this.container.style.opacity = "1";
    }, 100);
  }
  onClose(callback) {
    this.onCloseCallback = callback;
  }
  closePopup() {
    var _a;
    (_a = this.onCloseCallback) == null ? void 0 : _a.call(this);
    this.remove();
  }
}
export {
  BasePopup
};
